import { render, staticRenderFns } from "./NewsletterWidget.vue?vue&type=template&id=8b2467b2&"
import script from "./NewsletterWidget.vue?vue&type=script&lang=ts&"
export * from "./NewsletterWidget.vue?vue&type=script&lang=ts&"
import style0 from "./NewsletterWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports